import React from "react";

function renderBanner(banner) {
  if (banner == null) return null;
  if (typeof banner === "string") {
    return (
      <img
        src={banner}
        alt=""
        className="block w-full h-full min-h-[240px] object-cover object-center"
      />
    );
  }
  return banner;
}

/**
 * Two-column promo block: banner + “how it works” style copy.
 * @param {React.ReactNode} banner — Image URL string or React node (e.g. <img />).
 * @param {"left"|"right"} side — Banner column on the left or right (desktop); stacks on small screens.
 * @param {string} title — Section heading (default “HOW IT WORKS”).
 * @param {string[]} numberedList — Step copy; numbers are generated from index.
 */
export default function HowItWorksSplit({
  banner,
  side = "left",
  title = "HOW IT WORKS",
  numberedList = [],
  className = "",
}) {
  const isRight = side === "right";

  const bannerEl = (
    <div className="relative w-full h-full min-h-[240px] lg:min-h-[360px] overflow-hidden bg-ink">
      {renderBanner(banner)}
    </div>
  );

  const textEl = (
    <div className="flex flex-col justify-center px-6 py-10 md:px-10 md:py-12 lg:px-12 text-white">
      <h2 className="text-2xl md:text-3xl font-bold tracking-wide uppercase mb-1 md:mb-4 font-sf-pro-display">
        {title}
      </h2>
      <div className="h-px w-full max-w-md bg-white/15 mb-6" />
      {numberedList.length > 0 && (
        <ol className="m-0 p-0 list-none space-y-4 text-base md:text-lg leading-relaxed text-white/85">
          {numberedList.map((item, i) => (
            <li key={i} className="flex gap-3 font-normal">
              <span className="flex-shrink-0 font-semibold tabular-nums w-6 text-brand-blue-bright">
                {i + 1}.
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ol>
      )}
      <div className="text-[14px] md:text-[16px] mt-4">
        <p className="text-white/95 text-[14px] md:text-[16px] font-bold">
          Present your ticket at participating restaurants
        </p>
        <p className="text-white/95 mt-14">
          Don’t just see a show…
          <br />
          Make it a night to remember.
        </p>
        <p className="text-white/95 ">
          Dinner & A Show at the Orleans - available now.
        </p>
      </div>
    </div>
  );

  return (
    <section
      className={`bg-ink ${className}`.trim()}
      data-side={side}
    >
      <div
        className={`flex max-w-[1400px] mx-auto md:pt-10 ${
          isRight ? "flex-col lg:flex-row-reverse" : "flex-col-reverse lg:flex-row"
        }`}
      >
        <div className="w-full lg:w-1/2 flex flex-col">{bannerEl}</div>
        <div className="w-full lg:w-1/2 flex flex-col">{textEl}</div>
      </div>
    </section>
  );
}
